import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { NGXLogger } from "ngx-logger";
import { configuration, extAccessLog, extAccessSearchModel } from 'src/app/archive-external-access/models';
import { keyValuePair, property } from 'src/app/models';
import { callbackDisplayConfigModel } from 'src/app/callback-display/models';

@Injectable({
  providedIn: 'root'
})

export class SettingsService {


  constructor(private http: HttpService, private logger: NGXLogger) {
  }

  private _realtimeSettings: any = null;

  public async realtimeSettings(reload?: boolean): Promise<any> {
    if (this._realtimeSettings && !reload) {
      return this._realtimeSettings;
    }
    this._realtimeSettings = await firstValueFrom(this.http.getFromApi(`/Settings/RealtimeSettings`));
    return this._realtimeSettings;
  }
}
